import ResumeSkillForm from './ResumeSkillForm'

export default ResumeSkillForm
